export const telegramSessionProfiles = {
  'whatsapp-tech': {
    type: 'group',
    title: 'WhatsApp技术',
    sub: '群组 · 8 人在线',
    avatarText: '技',
   
    selfName: '我',
    selfAvatarText: '我',
    selfAvatarBackground: 'linear-gradient(135deg,#F05050,#D91E26)',
    members: ['吴彦祖-产品经理', '吴彦祖Agent', '刘德华-后端工程师', 'BioBio', '迪丽热巴', '刘亦菲'],
    groupAvatarLabels: ['吴', '刘', '迪', '菲', 'B', '技', '客', '账', '群'],
    defaultRequest: '把这段到账问题的处理结论整理一下',
    states: {
      empty: [
        { kind: 'day', text: '12:04' },
        { side: 'left', name: 'BioBio', nameColor: '#35A96B', avatarText: 'B', text: 'My today s reward?', time: '12:04' },
        { side: 'right', text: 'Already sent goshare account', time: '12:04' },
        { side: 'left', name: '吴彦祖-产品经理', nameColor: '#2F6ED8', agentTag: 'Agent', avatarText: '吴', text: '好的老板，收到，马上安排人去查看', time: '12:04' },
        { side: 'left', name: '吴彦祖Agent', nameColor: '#2F6ED8', agentTag: 'Agent', avatarText: '吴', text: '@刘德华-后端工程师 看一下是什么回事', time: '12:04' },
        { side: 'left', name: '刘德华-后端工程师', nameColor: '#7B61FF', agentTag: 'Agent', avatarText: '刘', replyTo: { name: '吴彦祖Agent', text: '@刘德华-后端工程师 看一下是什么回事', agentTag: 'Agent' }, text: '根据数据库查询结果，显示资金在10:58分已经发放到账户余额，请登录平台账号查看', time: '12:04' },
        { side: 'left', name: '迪丽热巴', nameColor: '#35B58A', avatarText: '迪', text: '晚上请你吃饭', time: '12:04' },
        { side: 'left', name: '刘亦菲', nameColor: '#F29B38', avatarText: '刘', text: '今晚有空吗', time: '12:04' },
        { side: 'right', text: 'OK啊', time: '12:04' }
      ],
      processing: [
        { kind: 'day', text: '12:04' },
        { side: 'left', name: 'BioBio', nameColor: '#35A96B', avatarText: 'B', text: 'My today s reward?', time: '12:04' },
        { side: 'right', text: 'Already sent goshare account', time: '12:04' },
        { side: 'left', name: '吴彦祖-产品经理', nameColor: '#2F6ED8', agentTag: 'Agent', avatarText: '吴', text: '好的老板，收到，马上安排人去查看', time: '12:04' },
        { side: 'left', name: '吴彦祖Agent', nameColor: '#2F6ED8', agentTag: 'Agent', avatarText: '吴', text: '@刘德华-后端工程师 看一下是什么回事', time: '12:04' },
        { side: 'left', name: '刘德华-后端工程师', nameColor: '#7B61FF', agentTag: 'Agent', avatarText: '刘', text: '收到，正在查看，请稍等，', time: '12:04' },
        { side: 'right', replyCurrent: true, text: '{{query}}', time: '12:05' },
        { side: 'left', name: '吴彦祖Agent', nameColor: '#2F6ED8', agentTag: 'Agent', avatarText: '吴', text: '收到，我先把问题链路和处理结果整理一下。', time: '12:05' },
        { side: 'left', typing: true, name: '吴彦祖Agent', nameColor: '#2F6ED8', agentTag: 'Agent', avatarText: '吴', time: '12:05' }
      ],
      result: [
        { kind: 'day', text: '12:04' },
        { side: 'left', name: 'BioBio', nameColor: '#35A96B', avatarText: 'B', text: 'My today s reward?', time: '12:04' },
        { side: 'right', text: 'Already sent goshare account', time: '12:04' },
        { side: 'left', name: '吴彦祖-产品经理', nameColor: '#2F6ED8', agentTag: 'Agent', avatarText: '吴', text: '好的老板，收到，马上安排人去查看', time: '12:04' },
        { side: 'left', name: '吴彦祖Agent', nameColor: '#2F6ED8', agentTag: 'Agent', avatarText: '吴', text: '@刘德华-后端工程师 看一下是什么回事', time: '12:04' },
        { side: 'left', name: '刘德华-后端工程师', nameColor: '#7B61FF', agentTag: 'Agent', avatarText: '刘', replyTo: { name: '吴彦祖Agent', text: '@刘德华-后端工程师 看一下是什么回事', agentTag: 'Agent' }, text: '根据数据库查询结果，显示资金在10:58分已经发放到账户余额，请登录平台账号查看', time: '12:04' },
        { side: 'right', replyCurrent: true, text: '{{query}}', time: '12:05' },
        { side: 'left', name: '吴彦祖-产品经理', nameColor: '#2F6ED8', agentTag: 'Agent', avatarText: '吴', text: '我把这段奖励到账的排查结论整理好了。', time: '12:06' },
        { side: 'left', kind: 'file', name: '吴彦祖-产品经理', nameColor: '#2F6ED8', agentTag: 'Agent', avatarText: '吴', title: '奖励到账排查说明.md', meta: 'Markdown · 17 KB', text: '结论：10:58 已发放到账户余额，建议优先引导用户登录平台账号核对。', time: '12:06' },
        { side: 'left', name: '迪丽热巴', nameColor: '#35B58A', avatarText: '迪', text: '晚上请你吃饭', time: '12:07' },
        { side: 'right', text: 'OK啊', time: '12:07' }
      ]
    }
  },
  'india-wa': {
    type: 'group',
    title: '印度Wa',
    sub: '群组 · 6 人在线',
    avatarText: '印',
   
    selfName: '我',
    selfAvatarText: '我',
    selfAvatarBackground: 'linear-gradient(135deg,#F05050,#D91E26)',
    members: ['吴彦祖Agent', '刘德华-后端工程师', '风控检测', '余额检测', '客户检测', '发送检测'],
    topicMembers: ['吴彦祖Agent', '刘德华-后端工程师', '林更新-运营', '许知夏'],
    groupAvatarLabels: ['吴', '刘', '风', '余', '客', '发', '印', '运', '群'],
    defaultRequest: '把这次掉线告警的结论整理一下',
    states: {
      empty: [
        { kind: 'day', text: '今天' },
        { side: 'left', name: '风控检测', nameColor: '#EF6A6A', avatarText: '风', text: '发送掉线率报警#当前掉线率:25.02%', time: '19:56' },
        { side: 'left', name: '余额检测', nameColor: '#2F6ED8', avatarText: '余', text: '账户余额目前正常，无需补充充值。', time: '19:57' },
        { side: 'right', text: '@吴彦祖Agent 看一下是怎么回事，先处理一下掉线问题。', time: '19:58' },
        { side: 'left', name: '吴彦祖Agent', nameColor: '#2F6ED8', agentTag: 'Agent', avatarText: '吴', text: '收到，我先核对掉线时间段和异常号码段。', time: '19:59' },
        { side: 'left', name: '吴彦祖Agent', nameColor: '#2F6ED8', agentTag: 'Agent', avatarText: '吴', text: '@刘德华-后端工程师 帮我查一下 19:50 - 20:00 的发送窗口', time: '19:59' },
        { side: 'left', name: '刘德华-后端工程师', nameColor: '#7B61FF', agentTag: 'Agent', avatarText: '刘', replyTo: { name: '吴彦祖Agent', text: '@刘德华-后端工程师 帮我查一下 19:50 - 20:00 的发送窗口', agentTag: 'Agent' }, text: '收到，正在查看风控和回执日志。', time: '20:00' }
      ],
      processing: [
        { kind: 'day', text: '今天' },
        { side: 'left', name: '风控检测', nameColor: '#EF6A6A', avatarText: '风', text: '发送掉线率报警#当前掉线率:25.02%', time: '19:56' },
        { side: 'left', name: '吴彦祖Agent', nameColor: '#2F6ED8', agentTag: 'Agent', avatarText: '吴', text: '@刘德华-后端工程师 帮我查一下 19:50 - 20:00 的发送窗口', time: '19:59' },
        { side: 'left', name: '刘德华-后端工程师', nameColor: '#7B61FF', agentTag: 'Agent', avatarText: '刘', text: '收到，正在查看风控和回执日志。', time: '20:00' },
        { side: 'right', replyCurrent: true, text: '{{query}}', time: '20:01' },
        { side: 'left', name: '吴彦祖Agent', nameColor: '#2F6ED8', agentTag: 'Agent', avatarText: '吴', text: '收到，我先把掉线原因、风险判断和处理建议整理一下。', time: '20:02' },
        { side: 'left', typing: true, name: '吴彦祖Agent', nameColor: '#2F6ED8', agentTag: 'Agent', avatarText: '吴', time: '20:02' }
      ],
      result: [
        { kind: 'day', text: '今天' },
        { side: 'left', name: '风控检测', nameColor: '#EF6A6A', avatarText: '风', text: '发送掉线率报警#当前掉线率:25.02%', time: '19:56' },
        { side: 'left', name: '吴彦祖Agent', nameColor: '#2F6ED8', agentTag: 'Agent', avatarText: '吴', text: '@刘德华-后端工程师 帮我查一下 19:50 - 20:00 的发送窗口', time: '19:59' },
        { side: 'left', name: '刘德华-后端工程师', nameColor: '#7B61FF', agentTag: 'Agent', avatarText: '刘', replyTo: { name: '吴彦祖Agent', text: '@刘德华-后端工程师 帮我查一下 19:50 - 20:00 的发送窗口', agentTag: 'Agent' }, text: '当前窗口内的异常主要集中在发送节奏过密。', time: '20:01' },
        { side: 'right', replyCurrent: true, text: '{{query}}', time: '20:01' },
        { side: 'left', name: '吴彦祖Agent', nameColor: '#2F6ED8', agentTag: 'Agent', avatarText: '吴', text: '我先把这次掉线告警整理成一版结论。', time: '20:03' },
        { side: 'left', kind: 'file', name: '吴彦祖Agent', nameColor: '#2F6ED8', agentTag: 'Agent', avatarText: '吴', title: '印度WA_风控检测结论.md', meta: 'Markdown · 18 KB', text: '当前结论：主要风险集中在发送窗口和号码健康度。', time: '20:03' }
      ]
    },
    topicStates: {
      risk: {
        empty: [
          { kind: 'day', text: '今天' },
          { side: 'left', name: '风控检测', nameColor: '#EF6A6A', avatarText: '风', text: '发送掉线率报警#当前掉线率:25.02%', time: '19:56' },
          { side: 'left', name: '余额检测', nameColor: '#2F6ED8', avatarText: '余', text: '账户余额目前正常，无需补充充值。', time: '19:57' },
          { side: 'right', text: '@吴彦祖Agent 看一下是怎么回事，先处理一下掉线问题。', time: '19:58' },
          { side: 'left', name: '吴彦祖Agent', nameColor: '#2F6ED8', agentTag: 'Agent', avatarText: '吴', text: '收到，我先核对掉线时间段和异常号码段。', time: '19:59' },
          { side: 'left', name: '吴彦祖Agent', nameColor: '#2F6ED8', agentTag: 'Agent', avatarText: '吴', text: '@刘德华-后端工程师 帮我查一下 19:50 - 20:00 的发送窗口', time: '19:59' },
          { side: 'left', name: '刘德华-后端工程师', nameColor: '#7B61FF', agentTag: 'Agent', avatarText: '刘', replyTo: { name: '吴彦祖Agent', text: '@刘德华-后端工程师 帮我查一下 19:50 - 20:00 的发送窗口', agentTag: 'Agent' }, text: '收到，正在查看风控和回执日志。', time: '20:00' }
        ],
        processing: [
          { kind: 'day', text: '今天' },
          { side: 'left', name: '风控检测', nameColor: '#EF6A6A', avatarText: '风', text: '发送掉线率报警#当前掉线率:25.02%', time: '19:56' },
          { side: 'left', name: '吴彦祖Agent', nameColor: '#2F6ED8', agentTag: 'Agent', avatarText: '吴', text: '@刘德华-后端工程师 帮我查一下 19:50 - 20:00 的发送窗口', time: '19:59' },
          { side: 'left', name: '刘德华-后端工程师', nameColor: '#7B61FF', agentTag: 'Agent', avatarText: '刘', text: '收到，正在查看风控和回执日志。', time: '20:00' },
          { side: 'right', replyCurrent: true, text: '{{query}}', time: '20:01' },
          { side: 'left', name: '吴彦祖Agent', nameColor: '#2F6ED8', agentTag: 'Agent', avatarText: '吴', text: '收到，我先把掉线原因、风险判断和处理建议整理一下。', time: '20:02' },
          { side: 'left', typing: true, name: '吴彦祖Agent', nameColor: '#2F6ED8', agentTag: 'Agent', avatarText: '吴', time: '20:02' }
        ],
        result: [
          { kind: 'day', text: '今天' },
          { side: 'left', name: '风控检测', nameColor: '#EF6A6A', avatarText: '风', text: '发送掉线率报警#当前掉线率:25.02%', time: '19:56' },
          { side: 'left', name: '吴彦祖Agent', nameColor: '#2F6ED8', agentTag: 'Agent', avatarText: '吴', text: '@刘德华-后端工程师 帮我查一下 19:50 - 20:00 的发送窗口', time: '19:59' },
          { side: 'left', name: '刘德华-后端工程师', nameColor: '#7B61FF', agentTag: 'Agent', avatarText: '刘', replyTo: { name: '吴彦祖Agent', text: '@刘德华-后端工程师 帮我查一下 19:50 - 20:00 的发送窗口', agentTag: 'Agent' }, text: '当前窗口内的异常主要集中在发送节奏过密。', time: '20:01' },
          { side: 'right', replyCurrent: true, text: '{{query}}', time: '20:01' },
          { side: 'left', name: '吴彦祖Agent', nameColor: '#2F6ED8', agentTag: 'Agent', avatarText: '吴', text: '我先把这次掉线告警整理成一版结论。', time: '20:03' },
          { side: 'left', kind: 'file', name: '吴彦祖Agent', nameColor: '#2F6ED8', agentTag: 'Agent', avatarText: '吴', title: '印度WA_风控检测结论.md', meta: 'Markdown · 18 KB', text: '当前结论：主要风险集中在发送窗口和号码健康度。', time: '20:03' }
        ]
      },
      balance: {
        empty: [
          { kind: 'day', text: '今天' },
          { side: 'left', name: '余额检测', nameColor: '#2F6ED8', avatarText: '余', text: '账户余额监控#当前余额正常', time: '19:41' },
          { side: 'right', text: '@吴彦祖Agent 帮我确认下这边余额波动是不是需要补款。', time: '19:42' },
          { side: 'left', name: '吴彦祖Agent', nameColor: '#2F6ED8', agentTag: 'Agent', avatarText: '吴', text: '收到，我先核对充值流水和当前消耗速度。', time: '19:43' },
          { side: 'left', name: '刘德华-后端工程师', nameColor: '#7B61FF', agentTag: 'Agent', avatarText: '刘', replyTo: { name: '吴彦祖Agent', text: '收到，我先核对充值流水和当前消耗速度。', agentTag: 'Agent' }, text: '刚核对完账本，当前余额还在安全线内。', time: '19:44' }
        ],
        processing: [
          { kind: 'day', text: '今天' },
          { side: 'left', name: '余额检测', nameColor: '#2F6ED8', avatarText: '余', text: '账户余额监控#当前余额正常', time: '19:41' },
          { side: 'left', name: '吴彦祖Agent', nameColor: '#2F6ED8', agentTag: 'Agent', avatarText: '吴', text: '收到，我先核对充值流水和当前消耗速度。', time: '19:43' },
          { side: 'right', replyCurrent: true, text: '{{query}}', time: '19:45' },
          { side: 'left', name: '吴彦祖Agent', nameColor: '#2F6ED8', agentTag: 'Agent', avatarText: '吴', text: '我先整理余额状态、充值建议和风险阈值。', time: '19:46' },
          { side: 'left', typing: true, name: '吴彦祖Agent', nameColor: '#2F6ED8', agentTag: 'Agent', avatarText: '吴', time: '19:46' }
        ],
        result: [
          { kind: 'day', text: '今天' },
          { side: 'left', name: '余额检测', nameColor: '#2F6ED8', avatarText: '余', text: '账户余额监控#当前余额正常', time: '19:41' },
          { side: 'left', name: '刘德华-后端工程师', nameColor: '#7B61FF', agentTag: 'Agent', avatarText: '刘', text: '刚核对完账本，当前余额还在安全线内。', time: '19:44' },
          { side: 'right', replyCurrent: true, text: '{{query}}', time: '19:45' },
          { side: 'left', name: '吴彦祖Agent', nameColor: '#2F6ED8', agentTag: 'Agent', avatarText: '吴', text: '余额这块我整理好了，当前无需补款。', time: '19:48' },
          { side: 'left', kind: 'file', name: '吴彦祖Agent', nameColor: '#2F6ED8', agentTag: 'Agent', avatarText: '吴', title: '印度WA_余额检测结论.md', meta: 'Markdown · 12 KB', text: '当前余额在安全阈值内，建议继续观察晚高峰消耗速度。', time: '19:48' }
        ]
      },
      customer: {
        empty: [
          { kind: 'day', text: '今天' },
          { side: 'left', name: '客户检测', nameColor: '#7B61FF', avatarText: '客', text: '客户活跃检测#今日触达稳定', time: '19:26' },
          { side: 'right', text: '@吴彦祖Agent 看下客户活跃波动有没有异常。', time: '19:27' },
          { side: 'left', name: '吴彦祖Agent', nameColor: '#2F6ED8', agentTag: 'Agent', avatarText: '吴', text: '收到，我先看新增、活跃和流失曲线。', time: '19:28' },
          { side: 'left', name: '刘德华-后端工程师', nameColor: '#7B61FF', agentTag: 'Agent', avatarText: '刘', text: '客户触达量正常，活跃峰值出现在 18:20。', time: '19:29' }
        ],
        processing: [
          { kind: 'day', text: '今天' },
          { side: 'left', name: '客户检测', nameColor: '#7B61FF', avatarText: '客', text: '客户活跃检测#今日触达稳定', time: '19:26' },
          { side: 'left', name: '吴彦祖Agent', nameColor: '#2F6ED8', agentTag: 'Agent', avatarText: '吴', text: '收到，我先看新增、活跃和流失曲线。', time: '19:28' },
          { side: 'right', replyCurrent: true, text: '{{query}}', time: '19:30' },
          { side: 'left', name: '吴彦祖Agent', nameColor: '#2F6ED8', agentTag: 'Agent', avatarText: '吴', text: '我先整理客户触达、留存和异常波动点。', time: '19:31' },
          { side: 'left', typing: true, name: '吴彦祖Agent', nameColor: '#2F6ED8', agentTag: 'Agent', avatarText: '吴', time: '19:31' }
        ],
        result: [
          { kind: 'day', text: '今天' },
          { side: 'left', name: '客户检测', nameColor: '#7B61FF', avatarText: '客', text: '客户活跃检测#今日触达稳定', time: '19:26' },
          { side: 'left', name: '刘德华-后端工程师', nameColor: '#7B61FF', agentTag: 'Agent', avatarText: '刘', text: '客户触达量正常，活跃峰值出现在 18:20。', time: '19:29' },
          { side: 'right', replyCurrent: true, text: '{{query}}', time: '19:30' },
          { side: 'left', name: '吴彦祖Agent', nameColor: '#2F6ED8', agentTag: 'Agent', avatarText: '吴', text: '客户活跃这块没有明显异常，我整理了一版结论。', time: '19:33' },
          { side: 'left', kind: 'file', name: '吴彦祖Agent', nameColor: '#2F6ED8', agentTag: 'Agent', avatarText: '吴', title: '印度WA_客户检测结论.md', meta: 'Markdown · 14 KB', text: '今日客户触达稳定，留存未见突发波动，建议继续观察晚间活跃峰值。', time: '19:33' }
        ]
      },
      sending: {
        empty: [
          { kind: 'day', text: '今天' },
          { side: 'left', name: '发送检测', nameColor: '#F29B38', avatarText: '发', text: '发送质量检测#队列运行正常', time: '19:18' },
          { side: 'right', text: '@吴彦祖Agent 看一下发送链路有没有阻塞。', time: '19:19' },
          { side: 'left', name: '吴彦祖Agent', nameColor: '#2F6ED8', agentTag: 'Agent', avatarText: '吴', text: '收到，我先查队列堆积和回执成功率。', time: '19:20' },
          { side: 'left', name: '刘德华-后端工程师', nameColor: '#7B61FF', agentTag: 'Agent', avatarText: '刘', text: '当前队列延迟 1.2s，未见明显阻塞。', time: '19:21' }
        ],
        processing: [
          { kind: 'day', text: '今天' },
          { side: 'left', name: '发送检测', nameColor: '#F29B38', avatarText: '发', text: '发送质量检测#队列运行正常', time: '19:18' },
          { side: 'left', name: '吴彦祖Agent', nameColor: '#2F6ED8', agentTag: 'Agent', avatarText: '吴', text: '收到，我先查队列堆积和回执成功率。', time: '19:20' },
          { side: 'right', replyCurrent: true, text: '{{query}}', time: '19:22' },
          { side: 'left', name: '吴彦祖Agent', nameColor: '#2F6ED8', agentTag: 'Agent', avatarText: '吴', text: '我先整理发送链路、延迟和回执情况。', time: '19:23' },
          { side: 'left', typing: true, name: '吴彦祖Agent', nameColor: '#2F6ED8', agentTag: 'Agent', avatarText: '吴', time: '19:23' }
        ],
        result: [
          { kind: 'day', text: '今天' },
          { side: 'left', name: '发送检测', nameColor: '#F29B38', avatarText: '发', text: '发送质量检测#队列运行正常', time: '19:18' },
          { side: 'left', name: '吴彦祖Agent', nameColor: '#2F6ED8', agentTag: 'Agent', avatarText: '吴', text: '收到，我先查队列堆积和回执成功率。', time: '19:20' },
          { side: 'right', replyCurrent: true, text: '{{query}}', time: '19:22' },
          { side: 'left', name: '吴彦祖Agent', nameColor: '#2F6ED8', agentTag: 'Agent', avatarText: '吴', text: '发送链路这块整理好了，当前无明显阻塞。', time: '19:25' },
          { side: 'left', kind: 'file', name: '吴彦祖Agent', nameColor: '#2F6ED8', agentTag: 'Agent', avatarText: '吴', title: '印度WA_发送检测结论.md', meta: 'Markdown · 11 KB', text: '队列延迟正常，回执率稳定，建议持续监控高峰期发送节奏。', time: '19:25' }
        ]
      }
    }
  },
  'zhou': {
    type: 'coworker',
    title: '周景行',
    sub: '在线',
    avatarText: '周',
   
    selfName: '我',
    selfAvatarText: '我',
    selfAvatarBackground: 'linear-gradient(135deg,#F05050,#D91E26)',
    defaultRequest: '把登录页静态稿和相关文件发我',
    states: {
      empty: [
        { kind: 'day', text: '今天' },
        { side: 'left', text: '我把竞品登录页的静态稿做了一版，顺手导出了 HTML 和样式文件。', time: '16:05' },
        { side: 'left', kind: 'file', title: 'login-preview.html', meta: 'HTML · 24 KB', text: '可以直接预览页面结构和交互占位。', time: '16:06' },
        { side: 'left', kind: 'file', title: 'login-style.css', meta: 'CSS · 8 KB', text: '样式我拆出来了，方便你直接看。', time: '16:06' },
        { side: 'right', text: '好，你把文件发我，我右侧看看。', time: '16:08' }
      ],
      processing: [
        { kind: 'day', text: '今天' },
        { side: 'left', text: '我把竞品登录页的静态稿做了一版，顺手导出了 HTML 和样式文件。', time: '16:05' },
        { side: 'left', kind: 'file', title: 'login-preview.html', meta: 'HTML · 24 KB', text: '可以直接预览页面结构和交互占位。', time: '16:06' },
        { side: 'left', kind: 'file', title: 'login-style.css', meta: 'CSS · 8 KB', text: '样式我拆出来了，方便你直接看。', time: '16:06' },
        { side: 'right', replyCurrent: true, text: '{{query}}', time: '16:09' },
        { side: 'left', text: '收到，我再补一个交互说明文档，一起发你。', time: '16:10' }
      ],
      result: [
        { kind: 'day', text: '今天' },
        { side: 'left', text: '我把竞品登录页的静态稿做了一版，顺手导出了 HTML 和样式文件。', time: '16:05' },
        { side: 'left', kind: 'file', title: 'login-preview.html', meta: 'HTML · 24 KB', text: '可以直接预览页面结构和交互占位。', time: '16:06' },
        { side: 'left', kind: 'file', title: 'login-style.css', meta: 'CSS · 8 KB', text: '样式我拆出来了，方便你直接看。', time: '16:06' },
        { side: 'right', replyCurrent: true, text: '{{query}}', time: '16:09' },
        { side: 'left', text: '我把交互说明也整理好了，一起发你。', time: '16:12' },
        { side: 'left', kind: 'file', title: '交互说明.md', meta: 'Markdown · 12 KB', text: '包含页面结构说明、表单交互和按钮状态描述。', time: '16:12' }
      ]
    }
  },
  'xuzhixia': {
    type: 'coworker',
    title: '许知夏',
    sub: '最近在线',
    avatarText: '许',
   
    selfName: '我',
    selfAvatarText: '我',
    selfAvatarBackground: 'linear-gradient(135deg,#F05050,#D91E26)',
    defaultRequest: '先把访谈里的重点聊清楚',
    states: {
      empty: [
        { kind: 'day', text: '今天' },
        { side: 'left', text: '我这边先把用户访谈里最典型的两个抱怨点记下来了。', time: '11:42' },
        { side: 'right', text: '你先口头跟我过一下，不用发文件。', time: '11:44' },
        { side: 'left', text: '行，我先直接跟你说结论。', time: '11:45' }
      ],
      processing: [
        { kind: 'day', text: '今天' },
        { side: 'left', text: '我这边先把用户访谈里最典型的两个抱怨点记下来了。', time: '11:42' },
        { side: 'right', replyCurrent: true, text: '{{query}}', time: '11:46' },
        { side: 'left', text: '好，我先把问题背景和用户原话口头过一遍。', time: '11:47' }
      ],
      result: [
        { kind: 'day', text: '今天' },
        { side: 'left', text: '我这边先把用户访谈里最典型的两个抱怨点记下来了。', time: '11:42' },
        { side: 'right', replyCurrent: true, text: '{{query}}', time: '11:46' },
        { side: 'left', text: '先这样，我们今天先口头对齐，文件晚点再整理。', time: '11:49' }
      ]
    }
  }
}

export const sessionTopicPages = {
  'wuyanzu-topics': {
    sessionKey: 'wuyanzu',
    title: '吴彦祖-产品经理',
    sub: '3 个话题',
    activeKey: 'wa',
    topics: [
      { key: 'wa', label: 'WA项目', name: 'WA项目', time: '20:36', author: 'egy_alert_jdioasoidsa_bot:', preview: '在线数记录#在线总...', message: 'egy_alert_jdioasoidsa_bot:在线数记录#在线总...', unread: '3', icon: 'W', color: 'linear-gradient(135deg,#F06A6A,#F69A9A)', topicTag: 'Agent' },
      { key: 'tg', label: 'TG项目', name: 'TG项目', time: '20:28', author: 'tgy_alert_jdioasoidsa_bot:', preview: '在线数记录#TG在线总...', message: 'tgy_alert_jdioasoidsa_bot:在线数记录#TG在线总...', unread: '6', icon: 'T', color: 'linear-gradient(135deg,#57B2FF,#7AC8FF)', topicTag: 'Agent' },
      { key: 'ins', label: 'INS项目', name: 'INS项目', time: '20:14', author: 'ins_alert_jdioasoidsa_bot:', preview: '在线数记录#INS在线总...', message: 'ins_alert_jdioasoidsa_bot:在线数记录#INS在线总...', unread: '2', icon: 'I', color: 'linear-gradient(135deg,#F0A83D,#F5C768)', topicTag: 'Agent' }
    ]
  },
  'india-wa-topics': {
    sessionKey: 'india-wa',
    title: '印度Wa',
    sub: '4 个话题',
    activeKey: 'risk',
    topics: [
      { key: 'risk', label: '风控检测', name: '风控检测', time: '19:56', author: '', preview: '发送掉线率报警#当前掉线率:25.02%', message: '发送掉线率报警#当前掉线率:25.02%', unread: '8', icon: '风', color: 'linear-gradient(135deg,#F06A6A,#F69A9A)', topicTag: 'Agent' },
      { key: 'balance', label: '余额检测', name: '余额检测', time: '19:41', author: '', preview: '账户余额监控#当前余额正常', message: '账户余额目前正常，无需补充充值。', unread: '2', icon: '余', color: 'linear-gradient(135deg,#57B2FF,#7AC8FF)' },
      { key: 'customer', label: '客户检测', name: '客户检测', time: '19:26', author: '', preview: '客户活跃检测#今日触达稳定', message: '客户活跃检测#今日触达稳定', unread: '1', icon: '客', color: 'linear-gradient(135deg,#7B61FF,#A28BFF)' },
      { key: 'sending', label: '发送检测', name: '发送检测', time: '19:18', author: '', preview: '发送质量检测#队列运行正常', message: '发送质量检测#队列运行正常', unread: '5', icon: '发', color: 'linear-gradient(135deg,#F0A83D,#F5C768)' }
    ]
  }
}

export const groupWorkspaceCloudComputers = {
  'whatsapp-tech': [
    { owner: '吴彦祖-产品经理', title: '吴彦祖-产品经理的电脑', subtitle: '产品决策桌面', status: '在线', task: '正在整理 PRD 与用户反馈，准备同步给群里的 Agent。', time: '17:08' },
    { owner: '刘德华-后端工程师', title: '刘德华-后端工程师的电脑', subtitle: '接口联调桌面', status: '编译中', task: '正在核对服务端联调日志，等待最新接口回包。', time: '17:12' },
    { owner: '林更新-前端工程师', title: '林更新-前端工程师的电脑', subtitle: '页面实现桌面', status: '在线', task: '正在调整 IM 工作区交互，校对 hover 与全屏演示细节。', time: '17:16' },
    { owner: '数数-数据分析师', title: '数数-数据分析师的电脑', subtitle: '复盘分析桌面', status: '空闲', task: '等待同步今日转化数据，准备更新复盘图表。', time: '17:20' }
  ],
  'india-wa': [
    { owner: '吴彦祖-产品经理', title: '吴彦祖-产品经理的电脑', subtitle: '海外群协同桌面', status: '在线', task: '正在确认海外群协作流程与风控检测节奏。', time: '19:42' },
    { owner: '刘德华-后端工程师', title: '刘德华-后端工程师的电脑', subtitle: '服务排障桌面', status: '在线', task: '正在查看网关和消息同步日志，排查异常发送窗口。', time: '19:48' },
    { owner: '运运-运营策划', title: '运运-运营策划的电脑', subtitle: '排期协同桌面', status: '处理中', task: '正在整理达人排期表，准备同步给客户和群内 Agent。', time: '19:51' }
  ]
}

export const agentSessionProfiles = {
  wuyanzu: {
    key: 'wuyanzu',
    name: '吴彦祖-产品经理',
    mark: '吴',
    state: 'empty',
    sampleQuery: '自主Agent有哪些？',
    workspaceTitle: '吴彦祖-产品经理的电脑',
    processingReply: '好的，我将为您调研并整理目前主流的自主Agent（Autonomous Agents），请稍候。',
    resultReply: '这是为您整理的关于"自主Agent有哪些？"的调研报告，请查阅附件。',
    reportTitle: '自主Agent（Autonomous Agents）调研报告'
  },
  liudehua: {
    key: 'liudehua',
    name: '刘德华-后端工程师',
    mark: '刘',
    state: 'processing',
    sampleQuery: '竞品能力矩阵',
    workspaceTitle: '刘德华-后端工程师的电脑',
    processingReply: '收到，我先从接口能力、部署复杂度和稳定性三个维度整理竞品能力矩阵。',
    resultReply: '我把竞品能力矩阵整理好了，先发你这版三点总结。',
    reportTitle: '竞品能力矩阵 三点总结'
  }
}

export const agentInspectorProfiles = {
  wuyanzu: {
    soul: `你是吴彦祖-产品经理，一名专注于产品战略与用户洞察的 AI Agent。你的工作风格是条理清晰、深度思考，善于将复杂问题拆解为可执行的方案。`,
    memory: `已记录：用户偏好直接给出结论而非过程叙述。上次对话：产品竞品分析已完成，待同步给设计团队。`
  },
  liudehua: {
    soul: `你是刘德华-后端工程师，一名经验丰富的后端研发 Agent。你擅长系统架构设计、接口性能优化，行事严谨，注重代码质量。`,
    memory: `已记录：用户最近关注 API 响应时间优化和数据库查询效率。上次对话：完成了登录接口的压测报告。`
  }
}

export const agentTasksData = {
  wuyanzu: [
    {
      id: 'task-1', title: 'WA项目竞品分析', status: '进行中', priority: '高',
      frequency: '每日 09:00', lastRun: '今日 09:12', dueTime: '今日 18:00',
      desc: '整理并对比 3 家竞品的核心功能与定价策略，输出对比表格。',
      outputs: ['竞品对比表格', '分析报告 PDF'],
      steps: ['收集竞品官网信息', '整理功能对比维度', '填写对比表格', '撰写结论报告']
    },
    {
      id: 'task-2', title: 'TG项目需求梳理', status: '待开始', priority: '中',
      frequency: '每周一', lastRun: '未执行', dueTime: '明日 12:00',
      desc: '梳理 TG 项目 Q2 核心需求，拆解成任务清单。',
      outputs: ['需求清单文档'],
      steps: ['汇总各方需求', '优先级排序', '拆解子任务', '同步到项目管理工具']
    },
    {
      id: 'task-3', title: '周报整理', status: '已完成', priority: '低',
      frequency: '每周五 17:00', lastRun: '昨日 17:02', dueTime: '昨日',
      desc: '汇总本周产品侧工作进展，同步给团队。',
      outputs: ['周报文档'],
      steps: ['汇总本周工作', '整理成文档', '发送到群组']
    }
  ],
  liudehua: [
    {
      id: 'task-1', title: '接口错误率巡检', status: '运行中', priority: '高',
      frequency: '每天 10:00', lastRun: '今天 10:00', dueTime: '今日 18:00',
      desc: '自动汇总核心接口的错误率、耗时与异常日志。',
      outputs: ['接口健康报告.md'],
      steps: ['拉取接口监控指标', '识别异常耗时和错误率', '生成巡检结果并标记风险']
    },
    {
      id: 'task-2', title: '数据库索引复查', status: '已完成', priority: '中',
      frequency: '每周二 15:00', lastRun: '昨日 15:02', dueTime: '昨日',
      desc: '扫描数据库慢查询日志，检查缺失索引并给出优化建议。',
      outputs: ['索引优化报告'],
      steps: ['拉取慢查询日志', '分析高频慢查询', '输出索引建议文档']
    },
    {
      id: 'task-3', title: '版本回归提醒', status: '待执行', priority: '低',
      frequency: '每周四 20:00', lastRun: '未执行', dueTime: '本周四',
      desc: '版本发布前自动触发回归检查清单，提醒相关成员确认。',
      outputs: ['回归检查清单'],
      steps: ['拉取本周待发布版本', '生成回归检查项', '发送提醒消息']
    }
  ],
  'india-wa': [
    {
      id: 'task-1', title: '掉线率监控报警', status: '运行中', priority: '高',
      frequency: '每小时', lastRun: '刚刚', dueTime: '持续执行',
      desc: '实时监控 WA 账号掉线率，超过阈值自动触发报警通知。',
      outputs: ['掉线率报告'],
      steps: ['拉取账号在线状态', '计算掉线率', '超阈值发送报警']
    },
    {
      id: 'task-2', title: '余额低预警', status: '待执行', priority: '中',
      frequency: '每天 09:00', lastRun: '昨日 09:00', dueTime: '今日 09:00',
      desc: '检查账户余额，低于安全线时提前预警并提示补充充值。',
      outputs: ['余额预警报告'],
      steps: ['查询账户余额', '对比安全阈值', '生成预警通知']
    }
  ]
}
